import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

// 확인 다이얼로그 컴포넌트
function Confirmation({
  isOpen,
  onClose,
  onConfirm,
  title = "확인",
  mainText = "정말 진행하시겠습니까?",
  subText = "",
}) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: '12px',
          minWidth: '400px',
          maxWidth: '500px',
        }
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ pb: 1 }}>
        <Typography variant="h6" component="div" fontWeight={600}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ color: 'text.primary', mb: subText ? 1 : 0 }}>
          {mainText}
        </DialogContentText>
        {subText && (
          <DialogContentText sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            {subText}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onClose} 
          color="inherit" 
          variant="outlined"
          sx={{ borderRadius: '8px' }}
        >
          취소
        </Button>
        <Button 
          onClick={() => {
            onConfirm();
            onClose();
          }} 
          color="primary" 
          variant="contained"
          autoFocus
          sx={{ borderRadius: '8px' }}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default Confirmation;
